"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadSuccessWorkspaceLogoSaga = void 0;
var tslib_1 = require("tslib");
var getObjectFirstItem_1 = require("../../../utilities/get/getObjectFirstItem");
var takeGaurd_1 = require("../../../utilities/takeGaurd");
var patchWorkspacesSaga_1 = require("../patch/patchWorkspacesSaga");
var effects_1 = require("redux-saga/effects");
var uploadSuccessWorkspaceLogoSaga = function (_a) {
    var uploadSuccessAction, key;
    var _b;
    var uploadId = _a.uploadId, workspaceId = _a.workspaceId, ratio = _a.ratio;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!1) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('UPLOAD_SUCCESS')];
            case 1:
                uploadSuccessAction = _c.sent();
                key = (0, getObjectFirstItem_1.getObjectFirstItem)(uploadSuccessAction.successValues).key;
                if (!(key === uploadId)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, patchWorkspacesSaga_1.patchWorkspacesSaga)({
                        items: (_b = {},
                            _b[workspaceId] = {
                                data: {
                                    logoImage: {
                                        ratio: ratio,
                                        updateSeconds: Date.now() / 1000,
                                        publicUrl: '', // so that we use the uploaded image
                                    }
                                }
                            },
                            _b)
                    })];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'WORKSPACE_LOGO_UPLOADED_ACTION',
                        description: 'uploadSuccessWorkspaceLogoSaga',
                    })];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
exports.uploadSuccessWorkspaceLogoSaga = uploadSuccessWorkspaceLogoSaga;
